import Layout from "@/app/ui/layout/index.vue";
import { FlagsPermissionKulioner } from "@/feature-flags/flags-kulioner";
import KulionerList from "@/app/ui/views/kulioner/index.vue";
import KulionerDetail from "@/app/ui/views/kulioner/detail/index.vue";
import KulionerCustomer from "@/app/ui/views/kulioner/customer.vue";

const merchantMaskedPath = new Date().getTime() + Math.random() + "";
const customerMaskedPath = new Date().getTime() + Math.random() + "customer";

export default [
  {
    path: "/kulioner",
    redirect: "/kulioner/merchant",
    component: Layout,
    name: "kulioner",
    meta: {
      icon: "kulioner",
      children: true,
      header: true,
      title: "Pesanan Kulioner",
      name: "Pesanan Kulioner",
      customName: "Daftar pesanan kulioner",
      permission: FlagsPermissionKulioner.permission_kulioner_enable,
      maskedPath: new Date().getTime() + Math.random() + ""
    },
    children: [
      {
        path: "merchant",
        component: () => import("@/app/ui/views/kulioner/merchant/index.vue"),
        name: "kulioner-merchant",
        meta: {
          title: "Daftar pesanan Merchant",
          name: "Daftar pesanan Merchant",
          children: false,
          header: true,
          icon: "merchant",
          customName: "Daftar pesanan Merchant",
          permission: FlagsPermissionKulioner.permission_kulioner_enable,
          newLayout: true,
          maskedPath: merchantMaskedPath
        },
        children: [
          {
            path: "cycle/:id",
            name: "kulioner-merchant-tab-cycle",
            component: () =>
              import("@/app/ui/views/kulioner/merchant/tab-cycle.vue"),
            meta: {
              header: true,
              customName: "Daftar pesanan Merchant",
              permission: FlagsPermissionKulioner.permission_kulioner_enable,
              newLayout: true,
              maskedPath: merchantMaskedPath
            },
            children: [
              {
                path: "processed",
                name: "kulioner-merchant-tab-cycle-processed",
                component: () =>
                  import("@/app/ui/views/kulioner/merchant/tab-process.vue"),
                meta: {
                  header: true,
                  customName: "Daftar pesanan Merchant",
                  newLayout: true,
                  permission:
                    FlagsPermissionKulioner.permission_kulioner_enable,
                  maskedPath: merchantMaskedPath
                }
              },
              {
                path: "unprocessed",
                name: "kulioner-merchant-tab-cycle-unprocessed",
                component: () =>
                  import("@/app/ui/views/kulioner/merchant/tab-process.vue"),
                meta: {
                  header: true,
                  customName: "Daftar pesanan Merchant",
                  permission:
                    FlagsPermissionKulioner.permission_kulioner_enable,
                  newLayout: true,
                  maskedPath: merchantMaskedPath
                }
              }
            ]
          }
        ]
      },
      {
        path: "",
        component: KulionerCustomer,
        name: "kulioner-customer-list",
        meta: {
          title: "Daftar pesanan customer",
          name: "Daftar pesanan customer",
          children: false,
          header: true,
          icon: "trolly",
          permission: FlagsPermissionKulioner.permission_kulioner_enable,
          newLayout: true,
          maskedPath: customerMaskedPath
        },
        children: [
          {
            path: "",
            name: "kulioner-list",
            component: KulionerList,
            meta: {
              isAuth: true,
              permission: FlagsPermissionKulioner.permission_kulioner_enable,
              newLayout: true,
              customName: "Daftar pesanan customer",
              maskedPath: customerMaskedPath,
            }
          },
          {
            path: "detail/:id",
            name: "kulioner-detail",
            component: KulionerDetail,
            meta: {
              isAuth: true,
              permission:
                FlagsPermissionKulioner.permission_kulioner_detail_view,
              newLayout: true,
              customName: "Detail pesanan customer",
              maskedPath: customerMaskedPath,
            }
          }
        ]
      }
    ]
  }
];
